interface ReconnectSchedulerOptions {
  baseDelayMs: number;
  maxDelayMs: number;
  onReconnect: () => void;
}

/**
 * Экспоненциальный backoff с джиттером для реконнекта WebSocket.
 * Никогда не сдаётся насовсем — задержка между попытками растёт,
 * но капается maxDelayMs, а не останавливается после N попыток.
 */
export class ReconnectScheduler {
  private attempts = 0;
  private timer: ReturnType<typeof setTimeout> | null = null;

  constructor(private readonly options: ReconnectSchedulerOptions) {}

  /** Планирует следующую попытку, если она ещё не запланирована. */
  scheduleNext(): void {
    if (this.timer) return;

    this.attempts += 1;
    this.timer = setTimeout(() => {
      this.timer = null;
      this.options.onReconnect();
    }, this.nextDelay());
  }

  /** Сбрасывает счётчик попыток (вызывать при успешном подключении). */
  reset(): void {
    this.attempts = 0;
    this.cancel();
  }

  /** Отменяет запланированную попытку без сброса счётчика. */
  cancel(): void {
    if (!this.timer) return;
    clearTimeout(this.timer);
    this.timer = null;
  }

  private nextDelay(): number {
    const exponent = Math.min(this.attempts, 6);
    const delay = Math.min(
      this.options.baseDelayMs * 2 ** (exponent - 1),
      this.options.maxDelayMs,
    );
    const jitter = delay * 0.2 * Math.random();
    return delay + jitter;
  }
}
